export default __webpack_public_path__ + "static/media/course_loading.b2270508.png";